import type { Plante } from './database.types';

// Vite inkluderer bare filer som faktisk finnes. Behold originalbildet til
// hver illustrasjon er generert, kontrollert og lagt inn i prosjektet.
const LOKALE_BILDER = import.meta.glob<string>('../assets/planter/*.webp', {
  eager: true, query: '?url', import: 'default',
});

/** Lokale illustrasjoner har stabil plante-ID, uavhengig av sortering og navneendringer. */
const BILDER: Record<string, string> = {
  '852f52e2-0a12-4e64-87de-f326b4fbadbd': '/images/planter/agurkurt.webp', // Agurkurt (Borage)
  '729ad508-a598-4078-9745-35f477dc0ae3': '/images/planter/mizuna.webp', // Asia-salat (Mizuna)
  'bb5dd03f-9efc-43f8-8d7e-9433035d897b': '/images/planter/babyleaf.webp', // Babyleaf-mix
  'e5daff69-444c-4bb4-af91-d383de5d068d': '/images/planter/basilikum.webp', // Basilikum
  '4aec126b-5ef8-4013-873d-b54f78ae4baa': '/images/planter/blomkarse.webp', // Blomkarse
  '25ff228c-3252-4c43-bca7-a6e910bf00d3': '/images/planter/bok-choy.webp', // Bok Choy (mini)
  '25c2eae8-cd85-458b-8c57-46ef83c20caa': '/images/planter/cherrytomat.webp', // Cherry-tomat «Tiny Tim»
  'cb41822a-62c8-4b64-b0a3-3becf6918f3c': '/images/planter/chili.webp', // Chili «Prairie Fire»
  '2474050f-dc26-4b17-8876-e21ea708d74e': '/images/planter/dill.webp', // Dill
  '5403286e-40e0-477c-9773-aaa1197ffba0': '/images/planter/dvergbasilikum.webp', // Dvergbasilikum «Greek»
  '1733fa8f-a57c-4aea-a28d-ac94c3fb1518': '/images/planter/estragon.webp', // Estragon (fransk)
  '9e1c4776-2029-42ee-9e20-27c7d654ad0b': '/images/planter/fiol.webp', // Fiol
  '7c2b8eda-8a3f-4ac3-87fb-1e81b30a8d5f': '/images/planter/gresslok.webp', // Gressløk
  '969854b4-1cd6-421c-ac0f-c2cf5af50378': '/images/planter/gronnkal.webp', // Grønnkål (Dwarf Blue Curled)
  'ccc051f2-3a0c-4ffc-af9e-93f7bd3d5d4b': '/images/planter/jordbaer.webp', // Jordbær (alpine)
  '7453dd54-1daf-4e6d-b7d5-6445d66e5830': '/images/planter/kamille.webp', // Kamille (tysk)
  'c461e194-d99a-4a83-8ffd-e4b0c318c57e': '/images/planter/karse.webp', // Karse
  '75223e28-6514-494f-a82c-33e844979e46': '/images/planter/kjorvel.webp', // Kjørvel
  '7b59767b-0cb1-4f04-a029-a7399667db2e': '/images/planter/koriander.webp', // Koriander
  '5a56f486-a426-4b5b-9454-260bb634f414': '/images/planter/mangold.webp', // Mangold
  '96224e2b-6fe9-4ac3-bd95-98db01d5ebcb': '/images/planter/merian.webp', // Merian
  'a6335c48-a29c-44d4-96ae-bea0f2356f5b': '/images/planter/mikro-brokkoli.webp', // Mikrogrønt: Brokkoli
  '8d768c0d-01ba-4e3d-b58c-23e343c11c06': '/images/planter/mikro-ert.webp', // Mikrogrønt: Ert (pea shoots)
  '2d0ff959-be00-43d7-888a-5eac39f38a05': '/images/planter/mikro-reddik.webp', // Mikrogrønt: Reddik
  '1f02ffe6-7052-49fe-8b00-7f91de02e581': '/images/planter/mikro-rodkal.webp', // Mikrogrønt: Rødkål
  '0b23e38d-39a3-4c03-9c23-a679308953eb': '/images/planter/mikro-sennep.webp', // Mikrogrønt: Sennep
  'f6f58466-9551-4a48-8e51-1a8bbdf3a3cc': '/images/planter/mikro-solsikke.webp', // Mikrogrønt: Solsikke
  'a50bd619-fc37-4072-8fd5-66850615d3c8': '/images/planter/miniagurk.webp', // Mini-agurk
  'efb9806b-6d08-4a5d-af69-c8d3c49699fb': '/images/planter/minipaprika.webp', // Mini-paprika
  '8cdc4d4d-bd61-421b-a9b0-3e531d54b7e4': '/images/planter/mynte.webp', // Mynte (peppermynte)
  '1ec0498b-ad95-4e0c-a9e3-49a79d59f25a': '/images/planter/oregano.webp', // Oregano
  'f744fbae-edb7-4629-ad0a-3b134b8da970': '/images/planter/persille.webp', // Persille
  'a1348237-02e0-4c83-869b-6787d786ccb6': '/images/planter/ringblomst.webp', // Ringblomst (Calendula)
  '13b55d5a-195a-4605-b3dd-bbb147bb8657': '/images/planter/rosmarin.webp', // Rosmarin
  '8645560f-0cdf-4cef-9f64-6fe2d8885e72': '/images/planter/ruccola.webp', // Ruccola
  '64faa003-4ad6-4bb7-aaf9-638d0f08c783': '/images/planter/ruccola.webp', // Steinsennep (vill ruccola), deler bilde med Ruccola
  'f0735a42-b670-4779-a93d-af37d781d46e': '/images/planter/little-gem.webp', // Salat «Little Gem»
  '555a7561-c0cb-4f79-b72d-128a2546e16c': '/images/planter/butterhead.webp', // Salat (butterhead)
  'e12433cb-c03d-4298-acb7-d7f5d736bcc9': '/images/planter/salad-bowl.webp', // Salat (Salad Bowl)
  '2343e736-f338-4947-a5d5-03e0f6edef03': '/images/planter/salvie.webp', // Salvie
  '5e8b6b92-e9b8-4cf9-b909-79e01718e454': '/images/planter/sitronmelisse.webp', // Sitronmelisse
  '264f4371-9b9a-4786-8da3-6487d6d52aae': '/images/planter/spinat.webp', // Spinat (babyleaf)
  '0fd030d2-3abf-400d-8ec5-cea8d1690781': '/images/planter/stemorsblomst.webp', // Stemorsblomst
  '3e3ae6de-08a5-42b4-b74c-1b4c9ed1817e': '/images/planter/timian.webp', // Timian
  '023f1349-cfae-4969-b600-1a632d4b184c': '/images/planter/vannkarse.webp', // Vannkarse
};

export function medPlantebilde<T extends Pick<Plante, 'id' | 'bilde_url' | 'bilde_kilde'>>(plante: T): T {
  const sti = BILDER[plante.id];
  const bilde = sti ? LOKALE_BILDER[sti.replace('/images/', '../assets/')] : undefined;
  return bilde ? { ...plante, bilde_url: bilde, bilde_kilde: 'AI-generert illustrasjon' } : plante;
}
